import { render } from "./MSidebarNavigationUser.vue?vue&type=template&id=61f51e36&scoped=true"
import script from "./MSidebarNavigationUser.vue?vue&type=script&lang=js"
export * from "./MSidebarNavigationUser.vue?vue&type=script&lang=js"

import "./MSidebarNavigationUser.vue?vue&type=style&index=0&id=61f51e36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f51e36"]])

export default __exports__